import React from 'react';
import { motion } from 'framer-motion';
import { Book, Beaker, FlaskConical, Rocket } from 'lucide-react';
const tomos = [{
  number: '1',
  title: 'Teoría Aplicada',
  desc: 'al sector.',
  pages: '60 pág',
  icon: <Book className="w-5 h-5 text-accent-cyan" data-id="element-27" />
}, {
  number: '2',
  title: 'Actividades Prácticas',
  desc: 'situadas.',
  pages: '60 pág',
  icon: <Beaker className="w-5 h-5 text-accent-cyan" data-id="element-28" />
}, {
  number: '3',
  title: 'Guías de Laboratorio',
  desc: 'y Talleres.',
  pages: '60 pág',
  icon: <FlaskConical className="w-5 h-5 text-accent-cyan" data-id="element-29" />
}, {
  number: '4',
  title: 'Proyectos Integradores',
  desc: 'de cierre.',
  pages: '60 pág',
  icon: <Rocket className="w-5 h-5 text-accent-cyan" data-id="element-30" />
}];
export function ContentDetails() {
  return <section className="py-8 md:py-16 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-31">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="bg-primary-card/50 rounded-3xl p-5 md:p-10 border border-primary-card" data-id="element-32">
        <h2 className="text-2xl md:text-3xl font-bold mb-5 md:mb-8 text-center" data-id="element-33">
          En cada orientación recibís 4 cuadernillos:
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 mb-5 md:mb-8" data-id="element-34">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-center gap-3 md:gap-4 bg-primary p-3 md:p-4 rounded-xl border border-primary-card" data-id="element-35">
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-primary-card flex items-center justify-center shrink-0 font-heading font-bold text-lg md:text-xl text-accent-cyan" data-id="element-36">
                {tomo.number}
              </div>
              <div data-id="element-37">
                <div className="flex items-center gap-2 mb-1" data-id="element-38">
                  {tomo.icon}
                  <span className="text-sm font-medium text-text-muted bg-primary-card px-2 py-0.5 rounded" data-id="element-39">
                    {tomo.pages}
                  </span>
                </div>
                <p className="text-lg" data-id="element-40">
                  <strong className="text-text-main" data-id="element-41">
                    TOMO {tomo.number}:
                  </strong>{' '}
                  {tomo.title}{' '}
                  <span className="text-text-muted" data-id="element-42">{tomo.desc}</span>
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center pt-4 md:pt-6 border-t border-primary-card" data-id="element-43">
          <p className="text-lg md:text-2xl font-medium" data-id="element-44">
            Total por orientación:{' '}
            <span className="text-accent-cyan font-bold" data-id="element-45">240 páginas</span>.{' '}
            <br className="md:hidden" data-id="element-46" />
            Pack Total:{' '}
            <span className="text-accent-cyan font-bold" data-id="element-47">960 páginas</span>.
          </p>
        </div>
      </motion.div>
    </section>;
}